import { PopularEmplyersSection } from '../components/PopularRecruiterView/PopularEmployersSection';
import { NextPageContext } from 'next';
import Connection from '../connection/Connection';

export default PopularEmplyersSection;

export const getServerSideProps = async (context: NextPageContext) => {
  const connection = Connection.nextConnection(context);
  try {
    const result = await connection.get('home/recruiter-ordered', { from: 0, size: 8 });

    return {
      props: {
        value: result.recruiters,
        totalRecords: result.total,
      },
    };
  } catch (e) {
    console.log(e);
  }
};
